import { ProcessField } from '@shared/types/process';

/* oxlint-disable react/only-export-components */
import { createContext, useContext } from 'react';

export const LayoutViewContext = createContext<{
    fileUploadController: string;
    mainLayoutVariant: 'recipient' | 'provider' | 'readOnly';
    processFieldsById: Record<string, ProcessField>;
} | null>(null);

export const LayoutViewProvider = LayoutViewContext.Provider;

export const useLayoutViewContext = ({ ignoreError = false } = {}) => {
    const context = useContext(LayoutViewContext);
    if (!context) {
        if (ignoreError) {
            console.warn(
                'useLayoutViewContext must be used within a LayoutViewProvider',
            );

            return null;
        }

        throw new Error(
            'useLayoutViewContext must be used within a LayoutViewProvider',
        );
    }
    return context;
};
